var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLetterX(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.1089,
    cy: 11.8821,
    r: 11.3821,
    fill: "#DAE8FD",
    stroke: "#4399C5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86689 16H8.60589L11.8039 11.359L8.77489 6.965H10.1139L12.5449 10.514L14.9629 6.965H16.2239L13.1949 11.359L16.3929 16H15.0409L12.4669 12.204L9.86689 16Z",
    fill: "#0277AD"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetterX);
export default __webpack_public_path__ + "static/media/letterX.880d7c9034bf5ba588253f0041f427e9.svg";
export { ForwardRef as ReactComponent };